import { render } from "./retour_view_tab.vue?vue&type=template&id=f50c1be2"
import script from "./retour_view_tab.vue?vue&type=script&lang=js"
export * from "./retour_view_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__